import fileDownload from "js-file-download";

import { LOCALSTORAGE_ITEMS, ORIGINAL_TYPE } from "@constants";

import { actions } from "store/recording";
import {
  recordingsListThunk,
  createRecordingThunk,
  createRecordingTTSThunk,
  conversionOrderThunk,
  conversionRedoThunk,
  conversionsListThunk,
  updateRecordingThunk,
  deleteRecordingThunk,
  exportTakeThunk,
  reportConversionIssueThunk,
  fetchRecordingThunk,
  conversionCountThunk,
} from "thunks/recording";
import { notificationDisplay } from "./notification";
import localStorageService from "services/localStorage";
import { logger } from "utils/logger";
import eventsService, { EVENTS } from "services/events";
import { setDataModal, toggleModal } from "./modal";
import { MODALS } from "components/common/Modal/utils";

export const {
  recordingsListSetPaginationData,
  conversionsListSetPaginationData,
  recordingConversionReady,
  recordingSetSelectedOriginal,
  updateRecordingStage,
  addOriginalsToConvert,
  setNewOriginalData: _setNewOriginalData,
  clearNewOriginalData,
} = actions;

export const recordingsList = (payload) => async (dispatch) => {
  try {
    localStorageService.setItem(LOCALSTORAGE_ITEMS.newOriginalData, undefined);
    await dispatch(recordingsListThunk(payload)).unwrap();
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const createRecording = (payload) => async (dispatch) => {
  try {
    const data = await dispatch(createRecordingThunk(payload)).unwrap();
    // TODO check if this code ignored?
    const currentData = localStorageService.getItem(
      LOCALSTORAGE_ITEMS.newOriginalData
    );
    if (currentData) {
      localStorageService.setItem(LOCALSTORAGE_ITEMS.newOriginalData, {
        ...currentData,
        uploaded: [...(currentData.uploaded || []), data.id],
        type: ORIGINAL_TYPE.sts,
      });
    }
    return data;
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const createRecordingTTS = (payload) => async (dispatch) => {
  try {
    const data = await dispatch(createRecordingTTSThunk(payload)).unwrap();
    // TODO check if this code ignored?
    const currentData = localStorageService.getItem(
      LOCALSTORAGE_ITEMS.newOriginalData
    );
    if (currentData) {
      localStorageService.setItem(LOCALSTORAGE_ITEMS.newOriginalData, {
        ...currentData,
        uploaded: [data.id, ...(currentData.uploaded || [])],
        type: ORIGINAL_TYPE.tts,
      });
    }
    return data;
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const conversionOrder = (payload) => async (dispatch) => {
  try {
    const data = await dispatch(conversionOrderThunk(payload)).unwrap();
    return data;
  } catch (error) {
    if (error?.statusCode === 429) {
      dispatch(toggleModal({ modalId: MODALS.ttsRequestsLimit, open: true }));
      dispatch(
        setDataModal({
          modalId: MODALS.ttsRequestsLimit,
          data: {
            limit: payload?.limit,
            retryAfter: error?.retryAfter,
          },
        })
      );
    } else {
      dispatch(notificationDisplay("error", error));
    }
    logger.trace(error);
  }
};

export const updateRecording = (payload) => async (dispatch) => {
  try {
    await dispatch(updateRecordingThunk(payload)).unwrap();
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const deleteRecording = (payload) => async (dispatch) => {
  try {
    const data = await dispatch(deleteRecordingThunk(payload)).unwrap();
    const currentData = localStorageService.getItem(
      LOCALSTORAGE_ITEMS.newOriginalData
    );
    if (currentData && data && data.length > 0) {
      localStorageService.setItem(LOCALSTORAGE_ITEMS.newOriginalData, {
        ...currentData,
        uploaded: (currentData.uploaded || []).filter(
          (id) => id !== data[0].id
        ),
      });
    }
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const exportTake = (payload) => async (dispatch) => {
  try {
    const data = await dispatch(exportTakeThunk(payload)).unwrap();
    fileDownload(data.blob, data.filename);
  } catch (error) {
    logger.trace(error);
    dispatch(notificationDisplay("error", error));
  }
};

export const conversionRedo = (payload) => async (dispatch) => {
  try {
    await dispatch(conversionRedoThunk(payload)).unwrap();
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const conversionsList = (payload) => async (dispatch) => {
  try {
    await dispatch(conversionsListThunk(payload)).unwrap();
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const reportConversionIssue = (payload) => async (dispatch) => {
  try {
    await dispatch(reportConversionIssueThunk(payload)).unwrap();

    eventsService.track(EVENTS.SUBMIT_FEEDBACK, {
      type: "conversion_issue",
      topic: "Conversion Issue",
    });
  } catch (error) {
    dispatch(
      notificationDisplay(
        "error",
        "Something went wrong while trying report a conversion issue"
      )
    );
    logger.trace(error);
  }
};

export const setNewOriginalData = (payload) => (dispatch) => {
  try {
    dispatch(_setNewOriginalData(payload));
    localStorageService.setItem(LOCALSTORAGE_ITEMS.newOriginalData, payload);
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const fetchRecording = (payload) => (dispatch) => {
  try {
    dispatch(fetchRecordingThunk(payload));
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};

export const conversionCount = (payload) => (dispatch) => {
  try {
    dispatch(conversionCountThunk(payload));
  } catch (error) {
    dispatch(notificationDisplay("error", error));
    logger.trace(error);
  }
};
